import React from 'react'
import { useHistory } from 'react-router-dom'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import {
	StyledDivider,
	StyledMenu,
	MenuItem,
} from '../StyledComponents'
import { navData } from '../data'

function MenuLinks({ open, anchorEl, handleClose, handleClick }) {
	const history = useHistory()
	const handleBtnClick = url => {
		console.log(url)
		return url ? history.push(url) : null
	}

	return (
		<React.Fragment>
			{navData.map(menu => (
				<React.Fragment key={menu.label + menu.url}>
					<MenuItem
						{...(menu.label === 'Home' && {
							color: 'warning',
							variant: 'contained',
							disableElevation: true,
						})}
						{...(menu.subMenu ? {
							...(open && { 'aria-controls': 'sub-menu' }),
							...(open && { 'aria-expanded': 'true' }),
							'aria-haspopup': "true",
							onClick: (event) => {
								handleBtnClick(menu.url)
								handleClick(event)
							},
							id: 'menu-button',
							endIcon: <ArrowDropDown />,
						} : {
							onClick: () => handleBtnClick(menu.url)
						})}
					>
						{menu.label}
					</MenuItem>

					<StyledDivider orientation="vertical" />

					{menu.subMenu && (
						<StyledMenu
							id='sub-menu'
							anchorEl={anchorEl}
							open={open}
							className='subMenu'
							onClose={handleClose}
							MenuListProps={{
								'aria-labelledby': 'menu-button',
							}}
						>
							{menu.subMenu.map((sub, index) => (
								<React.Fragment>
									{index > 0 && (
										<StyledDivider orientation="vertical" />
									)}

									<MenuItem
										key={sub.label + sub.url}
										onClick={(event) => {
											handleBtnClick(sub.url)
											handleClose(event)
										}}
									>
										{sub.label}
									</MenuItem>
								</React.Fragment>
							))}
							<StyledDivider orientation="vertical" />
						</StyledMenu>
					)}
				</React.Fragment>
			))}
		</React.Fragment>
	)
}

export default MenuLinks
